import React, { useState } from 'react'
import { Trans } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'

import emailImg from '../../2021/images/email.svg'
import webImg from '../../2021/images/web.svg'
import AnimatedNumber from '../AnimatedNumber'
import { animated, useSpring, useTrail, useTransition } from 'react-spring'
import InView from 'react-intersection-observer'

const Communication: React.FC = () => {
	const [startEmailAnimation, setStartEmailAnimation] = useState(false)
	const [startPhoneAnimation, setStartPhoneAnimation] = useState(false)
	const [startWebAnimation, setStartWebAnimation] = useState(false)

	const animationEmailStyles = useSpring({
		transform: `translateX(${startEmailAnimation ? 0 : `200px`})`,
		opacity: startEmailAnimation ? 1 : 0,
		config: { mass: 1, tension: 400, friction: 80 },
		delay: 1000
	})

	const animationPhoneStyles = useSpring({
		transform: `translateX(${startPhoneAnimation ? 0 : `200px`})`,
		opacity: startPhoneAnimation ? 1 : 0,
		config: { mass: 1, tension: 400, friction: 80 },
		delay: 1000
	})

	const animationWebStyles = useSpring({
		transform: `translateX(${startWebAnimation ? 0 : `200px`})`,
		opacity: startWebAnimation ? 1 : 0,
		config: { mass: 1, tension: 400, friction: 80 },
		delay: 1000
	})

	return (
		<section className="mt-8">
			<div className="container text-md-center text-start">
				<div className="row">
					<div className="col-md">
						<div className="d-inline-block text-start">
							<svg
								width="94"
								height="94"
								viewBox="0 0 94 94"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								className={styles.iconPhone}
							>
								<path
									d="M93.9578 77.3664C93.7886 75.8174 93.0142 74.4337 91.7771 73.475L73.6623 59.4735C70.5831 57.0973 66.4284 56.8153 63.0672 58.7591L59.7359 60.6841C57.7056 61.8534 55.194 61.6992 53.3366 60.2629C50.6446 58.1913 46.6254 54.9127 42.779 51.0626C38.9628 47.2426 35.7443 43.2987 33.7178 40.663C32.2966 38.817 32.1387 36.3091 33.3117 34.2751L35.2366 30.9363C37.1805 27.5676 36.9022 23.4054 34.526 20.3374L20.5206 2.22251C19.566 0.985646 18.1899 0.211255 16.6371 0.0383113C15.0843 -0.14216 13.5691 0.320309 12.3697 1.31281C9.29417 3.8506 5.34253 7.16682 3.97036 8.54285C1.18802 11.3252 0 14.9686 0 20.7361C0 27.4624 12.3473 52.4803 27.2173 66.73C41.5159 81.6564 66.5338 94 73.2675 94C79.0314 94 82.6746 92.812 85.4494 90.0296C86.9345 88.5482 90.6192 84.1268 92.6795 81.6303C93.6758 80.4268 94.1269 78.9153 93.9578 77.3664ZM89.7844 79.235C86.3443 83.4045 83.7988 86.371 82.7949 87.3749C81.3098 88.8638 79.1252 90.2398 73.2637 90.2398C68.1015 90.2398 43.8506 78.6635 29.8717 64.0716C15.34 50.1415 3.75978 25.8982 3.75978 20.7361C3.75978 14.8746 5.1358 12.6902 6.62859 11.2013C7.62109 10.2086 10.5088 7.72715 14.7648 4.21173C15.1183 3.91853 15.5506 3.76431 16.0019 3.76431C16.0733 3.76431 16.1486 3.76817 16.22 3.77551C16.7502 3.83573 17.2202 4.09882 17.5472 4.52365L31.5525 22.6346C32.9887 24.4957 33.158 27.0148 31.9812 29.0563L30.0562 32.3949C28.1199 35.7486 28.3868 39.8958 30.7368 42.9526C32.831 45.6784 36.1585 49.7578 40.1213 53.7206C44.1104 57.7097 48.2651 61.1049 51.0435 63.2404C54.0965 65.6016 58.2512 65.8873 61.6161 63.9436C61.6161 63.9397 61.6161 63.9397 61.6161 63.9397L64.9473 62.0148C66.9852 60.8379 69.5079 61.0146 71.3654 62.451L89.4763 76.4488C89.8975 76.7759 90.1606 77.2496 90.2208 77.7798C90.2807 78.31 90.1264 78.8252 89.7844 79.235Z"
									fill="#5B5B5B"
								/>
								<path
									d="M65.229 7.40743C75.1775 11.0394 82.9603 18.8223 86.5885 28.7708C86.8666 29.5339 87.5885 30.0078 88.3556 30.0078C88.5698 30.0078 88.7842 29.9702 88.9948 29.8912C89.9724 29.5341 90.4762 28.4586 90.119 27.4812C86.1148 16.4912 77.5122 7.88513 66.5149 3.87713C65.5523 3.52372 64.462 4.0275 64.1049 4.9976C63.7476 5.97119 64.2516 7.05016 65.229 7.40743Z"
									fill="#DC0069"
									className={styles.iconPhoneThird}
								/>
								<path
									d="M60.0818 21.5482C65.7741 23.6048 70.3949 28.2293 72.4479 33.9179C72.7299 34.6849 73.4479 35.1586 74.2188 35.1586C74.433 35.1586 74.6475 35.1248 74.8579 35.0495C75.8355 34.6961 76.343 33.6208 75.9895 32.6432C73.5569 25.9169 68.0901 20.4464 61.36 18.0139C60.3899 17.6566 59.3071 18.1642 58.95 19.1418C58.5968 20.1195 59.1044 21.1948 60.0818 21.5482Z"
									fill="#DC0069"
									className={styles.iconPhoneSecond}
								/>
								<path
									d="M54.9421 35.6852C56.5175 36.2492 57.7507 37.4824 58.3147 39.0615C58.593 39.8322 59.3149 40.3097 60.0856 40.3097C60.2923 40.3097 60.5068 40.2759 60.7171 40.197C61.6984 39.8473 62.2061 38.772 61.8563 37.7945C60.9127 35.1513 58.8522 33.0911 56.2054 32.1472C55.2316 31.7938 54.1563 32.309 53.8029 33.2827C53.4531 34.2602 53.9608 35.3355 54.9421 35.6852Z"
									fill="#DC0069"
									className={styles.iconPhoneFirst}
								/>
							</svg>

							<animated.h4 className="h1 mt-4" style={animationPhoneStyles}>
								<Trans
									i18nKey={'communication.phone'}
									components={[<strong />]}
								/>
							</animated.h4>
							<strong className="display-2 text-primary">
								<AnimatedNumber number={958374} />
							</strong>
						</div>
						<InView
							onChange={(inView) => inView && setStartPhoneAnimation(true)}
						/>
					</div>
					<div className="col-md pt-5 pt-lg-7">
						<div className="d-inline-block text-start">
							<img src={emailImg} alt="" />
							<animated.h4 className="h1 mt-4" style={animationEmailStyles}>
								<Trans
									i18nKey={'communication.email'}
									components={[<strong />]}
								/>
							</animated.h4>
							<strong className="display-2 text-primary">
								<AnimatedNumber number={1942828} />
							</strong>
						</div>
					</div>
					<InView
						onChange={(inView) => inView && setStartEmailAnimation(true)}
					/>
				</div>
				<div className={`d-inline-block text-start pt-5 pt-lg-0 ${styles.web}`}>
					<img src={webImg} alt="" className={styles.iconWeb} />
					<animated.h4 className="h1 mt-4" style={animationWebStyles}>
						<Trans i18nKey={'communication.web'} components={[<strong />]} />
					</animated.h4>
					<strong className="display-2 text-primary">
						<AnimatedNumber number={430000000} />
					</strong>
				</div>
				<InView onChange={(inView) => inView && setStartWebAnimation(true)} />
			</div>
		</section>
	)
}

export default Communication
